import styled, { css } from "styled-components";
import { ServiceName } from "../../../../../../../constants";
import { fontMixin, getColorByService, getColorByServiceId } from "../../../../../../../styles";
import { motion } from "framer-motion";

interface CI_ContainerProps {
	$service: ServiceName;
	$isActive: boolean;
}

export const CI_Container = styled(motion.div)<CI_ContainerProps>`
	width: 170px;
	height: 250px;
	position: relative;
	display: grid;
	grid-template-rows: 20px 1fr;
	align-items: center;
	padding: 0 12px 12px;
	border-radius: 12px;
	background: #555;
	overflow: hidden;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);

	${({ $isActive, $service }) =>
		$isActive &&
		css`
			background: ${(props) => getColorByService($service)};
		`}
`;

export const CI_Name = styled(motion.div)`
	${fontMixin({ size: 14 })};
	line-height: 17px;
	text-transform: uppercase;
`;

export const CI_Progress = styled(motion.div)`
	position: absolute;
	right: 10px;
	bottom: 10px;
`;

export const courseItemVariants = {
	hidden: {
		opacity: 0,
		x: -14,
		scale: 0.94,
		filter: "blur(5px)",
	},
	visible: {
		opacity: 1,
		x: 0,
		scale: 1,
		filter: "blur(0px)",
		transition: {
			duration: 0.42,
			ease: [0.16, 1, 0.3, 1],
		},
	},
	exit: {
		opacity: 0,
		x: -8,
		scale: 0.96,
		filter: "blur(4px)",
		transition: {
			duration: 0.18,
		},
	},
};
